import { IsNotEmpty, MaxLength, IsString, IsBoolean, IsEmail, IsOptional } from 'class-validator';

export class TenantRegisterDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    firstName: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    lastName: string;

    @IsNotEmpty()
    @IsEmail()
    @MaxLength(255)
    email: string;

    @IsNotEmpty()
    @IsBoolean()
    acceptTermsOfAgreement: boolean;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    registrationReferer: string;

}
